import { List, Datagrid, TextField, NumberField, FunctionField } from 'react-admin';
import { Chip } from '@mui/material';

const StatusChip = ({ record }) => {
    if (!record || !record.status) return <Chip label="Новый" size="small" sx={{ bgcolor: '#E3F2FD', color: '#1565C0', fontWeight: 600 }} />;
    const statusMap = {
        'Новый': { bg: '#E3F2FD', color: '#1565C0' },
        'Подтверждён': { bg: '#FFF3E0', color: '#E65100' },
        'Отправлен': { bg: '#E8F5E9', color: '#2E7D32' },
        'Доставлен': { bg: '#F3E5F5', color: '#7B1FA2' },
        'Отменён': { bg: '#FFEBEE', color: '#C62828' },
    };
    const s = statusMap[record.status] || { bg: '#f5f5f5', color: '#666' };
    return <Chip label={record.status} size="small" sx={{ bgcolor: s.bg, color: s.color, fontWeight: 600 }} />;
};

const OrderList = () => (
    <List perPage={25} sort={{ field: 'id', order: 'DESC' }}>
        <Datagrid rowClick="edit" bulkActionButtons={false}>
            <TextField source="id" label="№" />
            <FunctionField label="Клиент" render={record => {
                const user = record?.user;
                if (!user) return '—';
                const name = [user.firstName, user.lastName].filter(Boolean).join(' ');
                return name || user.phone || '—';
            }} />
            <FunctionField label="Товар" render={record => {
                const products = record?.products;
                if (products && products.length > 0)
                    return products.map(p => p.name).join(', ');
                return 'Обратный звонок';
            }} />
            <NumberField source="price" label="Сумма" options={{ style: 'currency', currency: 'RUB', minimumFractionDigits: 0 }} />
            <FunctionField label="Статус" render={record => (
                <StatusChip record={record} />
            )} />
        </Datagrid>
    </List>
);

export default OrderList;
